export default __webpack_public_path__ + "static/media/warning--forest--g1.e558de15.png";